import setups, { SetupsState } from "./setups";
import parts, { PartsState } from "./parts";
import dialog, { DialogState } from "./modals";
import load from "./load";
import models from "./models";
import configuration, {
	ConfigurationState,
	initialConfigurationState
} from "./configuration";
import vehicleOverview, {
	VehicleOverviewState,
	vehicleInitialState
} from "./vehicleOverview";
import { MotorcycleModelResponse } from "../../components/main/motorcycles/MotorcycleView";
import toast, { ToastMessageState } from "./toast";
import views, { ViewsState, viewsInitialState } from "./views";
import { LOAD_CONFIGURATION } from "../actionTypes";
import Action from "./models/action";
import { initialState as modelInitialState } from "./models";
import { initialState as dialogInitialState } from "./modals";
import { initialState as partsInitialState } from "./parts";
import { initialState as setupsInitialState } from "./setups";
import { initialState as toastInitialState } from "./toast";

export interface Store {
	dialog: DialogState;
	configurationState: ConfigurationState;
	views: ViewsState;
	modelsResponse: MotorcycleModelResponse;
	vehicleOverviewState: VehicleOverviewState;
	parts: PartsState;
	setups: SetupsState;
	toast: ToastMessageState;
}

export const initialReduxState: Store = {
	dialog: { ...dialogInitialState },
	configurationState: {
		...initialConfigurationState
	},
	views: { ...viewsInitialState },
	modelsResponse: { ...modelInitialState },
	vehicleOverviewState: { ...vehicleInitialState },
	parts: { ...partsInitialState },
	setups: { ...setupsInitialState },
	toast: { ...toastInitialState }
};

export default function rootReducer(
	state: Store = initialReduxState,
	action: Action
): Store {
	if (action.type === LOAD_CONFIGURATION) {
		return load(state, action);
	}

	return {
		dialog: dialog(state.dialog, action),
		configurationState: configuration(state.configurationState, action),
		views: views(state.views, action),
		modelsResponse: models(state.modelsResponse, action),
		vehicleOverviewState: vehicleOverview(
			state.vehicleOverviewState,
			action as Required<Action>
		),
		parts: parts(state.parts, action, state),
		setups: setups(state.setups, action),
		toast: toast(state.toast, action)
	};
}
